<ng-container *ngIf="roadCondition" [formGroup]="roadCondition">
  <h4>What are the road conditions to the site?</h4>
  <div>(Select all that apply)</div>
  <div class="button-wrapper-grid">
    <div>
      <div [ngClass]="{ active: selected('paved') }" class="cnt-button">
        <label>
          <input type="checkbox" formControlName="paved" />
          <div class="cnt-button-copy">Paved</div>
        </label>
      </div>
      <textarea
        class="semi-rounded"
        *ngIf="selected('paved')"
        formControlName="pavedDescription"
        placeholder="Add optional description..."
      ></textarea>
    </div>
    <div>
      <label>
        <div [ngClass]="{ active: selected('smoothGravel') }" class="cnt-button">
          <input type="checkbox" formControlName="smoothGravel" />
          <div class="cnt-button-copy">Smooth Gravel</div>
        </div>
      </label>
      <textarea
        class="semi-rounded"
        *ngIf="selected('smoothGravel')"
        formControlName="smoothGravelDescription"
        placeholder="Add optional description..."
      ></textarea>
    </div>
    <div>
      <label>
        <div [ngClass]="{ active: selected('poorGravel') }" class="cnt-button">
          <input type="checkbox" formControlName="poorGravel" />
          <div class="cnt-button-copy">Poor Gravel</div>
        </div>
      </label>
      <textarea
        class="semi-rounded"
        *ngIf="selected('poorGravel')"
        formControlName="poorGravelDescription"
        placeholder="Add optional description..."
      ></textarea>
    </div>
    <div>
      <label>
        <div [ngClass]="{ active: selected('highClearance') }" class="cnt-button">
          <input type="checkbox" formControlName="highClearance" />
          <div class="cnt-button-copy">High Clearance</div>
        </div>
      </label>
      <textarea
        class="semi-rounded"
        *ngIf="selected('highClearance')"
        formControlName="highClearanceDescription"
        placeholder="Add optional description..."
      ></textarea>
    </div>
    <div>
      <label>
        <div [ngClass]="{ active: selected('offRoad') }" class="cnt-button">
          <input type="checkbox" formControlName="offRoad" />
          <div class="cnt-button-copy">Off-Road Path</div>
        </div>
      </label>
      <textarea
        class="semi-rounded"
        *ngIf="selected('offRoad')"
        formControlName="offRoadDescription"
        placeholder="Add optional description..."
      ></textarea>
    </div>
  </div>
</ng-container>
